import { isBrowser } from './isBrowser';
import { User, UserPermission } from '@graphql/types.generated';
import { DeepPartial } from './typeUtils';
import { mergeObjIgnoringUndefinedAndNull } from '.';
import { WarrantyUser } from 'services/api/type';

type Credentials = {
  token: string;
};

const noop = () => null;

const localStorage = isBrowser
  ? window.localStorage
  : {
      getItem: noop,
      setItem: noop,
      removeItem: noop,
    };

const parseCredentials = (credentials: Credentials) => {
  const { token, ...rest } = credentials;
  return {
    ...rest,
    token,
  };
};
export const getCredentials = () => {
  const credentials = localStorage.getItem('auth');
  if (credentials) {
    return JSON.parse(credentials);
  }
  return {};
};
export const storeCredentials = (credentials: Credentials) => {
  // localStorage is a synchronous API, hence no need for using async/await here
  const oldCredentials = getCredentials();
  localStorage.setItem(
    'auth',
    JSON.stringify(
      parseCredentials({
        ...oldCredentials,
        ...credentials,
      }),
    ),
  );
};

export const getUserData = (): User | undefined => {
  const userData = localStorage.getItem('user');
  if (userData) {
    return JSON.parse(userData);
  }

  return undefined;
};

export const storeUserPermission = (permissions: UserPermission[]) => {
  localStorage.setItem('permissions', JSON.stringify(permissions));
};

export const getUserPermission = (): UserPermission[] | undefined => {
  const userPermission = localStorage.getItem('permissions');
  if (userPermission) {
    return JSON.parse(userPermission);
  }
  return undefined;
};

export const storeUserData = (userData: DeepPartial<User>) => {
  const oldUserData = getUserData() ?? {};
  const newUserData = mergeObjIgnoringUndefinedAndNull(oldUserData, userData);

  localStorage.setItem('user', JSON.stringify(newUserData));
};

export const logout = () => {
  localStorage.removeItem('auth');
  localStorage.removeItem('user');
  localStorage.removeItem('bypassBy');
  localStorage.removeItem('permissions');
  // trigger storage event
  // window.dispatchEvent(new CustomEvent('storage', { detail: { key: 'auth' } }));
};

export const logoutWarranty = () => {
  localStorage.removeItem('w-auth');
  localStorage.removeItem('w-user');
  localStorage.removeItem('w-permissions');
};

export const getWarrantyUserData = (): WarrantyUser | undefined => {
  const userData = localStorage.getItem('w-user');
  if (userData) {
    return JSON.parse(userData);
  }

  return undefined;
};
export const storeWarrantyUserData = (userData: DeepPartial<WarrantyUser>) => {
  const oldUserData = getWarrantyUserData() ?? {};
  const newUserData = mergeObjIgnoringUndefinedAndNull(oldUserData, userData);

  localStorage.setItem('w-user', JSON.stringify(newUserData));
};
